module.exports = __webpack_public_path__ + "co.svg?884797ba3ba63eccdf9348b6d6892950";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/co.svg
// module id = 1224
// module chunks = 27